import React from "react";
import "./loadingScreen.css";
const LoadingScreen = () => {
  return (
    <div className='loading-screen'>
      <div className='loader'></div>
    </div>
  );
};

export default LoadingScreen;
